import React, { useEffect, useState } from "react";
import "./userLocation.css";
import NavigationIcon from "@mui/icons-material/Navigation";

const MarkerMap = ({ type, userHeading = 0 }) => {
  const [scale, setScale] = useState(1);
  // const [rotation, setRotation] = useState(userHeading);

  useEffect(() => {
    // Animación de pulso
    const pulseInterval = setInterval(() => {
      setScale((prev) => (prev === 1 ? 1.2 : 1));
    }, 1000);

    return () => clearInterval(pulseInterval);
  }, []);

  useEffect(() => {
    // Animación suave de rotación
    const timer = setTimeout(() => {
      // setRotation(userHeading);
    }, 50); // Pequeño delay para suavizar la transición

    return () => clearTimeout(timer);
  }, [userHeading]);

  if (type !== "location") {
    return (
      <div className="marker-default">
        <NavigationIcon />
      </div>
    );
  }

  return (
    <div className="marker-outer">
      <div className="marker-wrapper" style={{ transform: `scale(${scale})` }}>
        <div className="marker-container">
          <NavigationIcon sx={{ color: "#E7EF7D" }} />
        </div>
      </div>
    </div>
  );
};

export default React.memo(MarkerMap);
